import {includes} from "../const/ForTrans";

export default function CheckboxInput({label, onChange, toChange, metaData}){

    return(
        <label >
            <input type="checkbox" style={{height:"auto"}} checked={includes(metaData.ai,label)}
                   onChange={()=>onChange? onChange(label, toChange, !includes(metaData.ai, label)):alert('변경 불가능합니다.')}/>
            {label}
        </label>
    )
}